import { configureStore } from "@reduxjs/toolkit";
import refineryReducer from "../features/refineries/refinerySlice";
import plumeReducer from "../features/plume/plumeSlice";
import facilityReducer from "../features/facilities/facilitiesSlice";
import loadingSlice from "../features/loading/loadingSlice";
import snackbarSlice from "../features/snackbar/snackbar";
import emissionSourceSlice from "../features/emissionSource/emissionSourceSlice";
import placesSlice from "../features/places/placesSlice";
import loginSlice from "../features/login/loginSlice";
import occurrenceSlice from "../features/occurrence/occurrenceSlice";
import inventorySlice from "../features/inventory/Slice";
import offlineJobSlice from "../features/offlineJob/offlineJobSlice";

// Persistência leve do slice `facilities` em localStorage (sem redux-persist)
// — preserva a seleção de projeto entre abas e recargas.
const FACILITIES_STORAGE_KEY = "airesflow.facilities.v1";
const loadFacilitiesPreloadedState = () => {
  try {
    const raw = localStorage.getItem(FACILITIES_STORAGE_KEY);
    if (!raw) return undefined;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return undefined;
    return { facilities: parsed };
  } catch {
    return undefined;
  }
};

export const store = configureStore({
  reducer: {
    refinery: refineryReducer,
    plume: plumeReducer,
    facilities: facilityReducer,
    loading: loadingSlice,
    snackbar: snackbarSlice,
    emissionSource: emissionSourceSlice,
    places: placesSlice,
    login: loginSlice,
    occurrence: occurrenceSlice,
    inventory: inventorySlice,
    offlineJob: offlineJobSlice,
  },
  preloadedState: loadFacilitiesPreloadedState(),
});

// Sincroniza alterações do slice `facilities` com localStorage.
let lastFacilitiesSerialized: string | null = null;
store.subscribe(() => {
  try {
    const { facilities } = store.getState();
    const serialized = JSON.stringify(facilities);
    if (serialized !== lastFacilitiesSerialized) {
      lastFacilitiesSerialized = serialized;
      localStorage.setItem(FACILITIES_STORAGE_KEY, serialized);
    }
  } catch {
    /* ignora falhas de quota / serialização */
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
